/*
 * VT — sticky mobile add-to-cart bar.
 *
 * Deliberately does NOT re-implement variant selection or cart logic:
 * it mirrors the current variant's price / availability / option summary
 * from the main product form, and its buttons simply trigger the real
 * add-to-cart / dynamic-checkout buttons already on the page. This keeps
 * it correct regardless of how Dawn's variant picker updates the DOM
 * under the hood.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.vt-sticky-atc').forEach(initStickyAtc);
  });

  function initStickyAtc(bar) {
    var sectionId = bar.dataset.section;
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    var scope = productInfo || document;
    var mq = window.matchMedia('(max-width: 989px)');

    function submitButton() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }

    function syncPrice() {
      var source = scope.querySelector('.price');
      var target = bar.querySelector('.vt-sticky-atc__price');
      if (!source || !target) return;
      // Copy the whole `.price` element (outerHTML), not just its inner
      // content: Dawn's Sale/Sold-out badge visibility is controlled by
      // modifier classes (price--on-sale, price--sold-out) on this outer
      // element. Copying only innerHTML previously dropped those classes,
      // so both badges fell back to visible regardless of actual stock.
      if (source.outerHTML !== target.firstElementChild?.outerHTML) {
        target.innerHTML = source.outerHTML;
      }
    }

    function syncVariantLabel() {
      var labelEl = bar.querySelector('.vt-sticky-atc__variant-label');
      if (!labelEl) return;
      var parts = [];
      var groups = scope.querySelectorAll(
        'variant-radios fieldset, variant-selects .product-form__input--dropdown'
      );
      groups.forEach(function (group) {
        var checkedInput = group.querySelector('input[type="radio"]:checked');
        var select = group.querySelector('select');
        if (checkedInput) {
          parts.push(checkedInput.value);
        } else if (select && select.selectedIndex > -1) {
          parts.push(select.options[select.selectedIndex].text.split(' - ')[0].trim());
        }
      });
      if (parts.length) labelEl.textContent = parts.join(' · ');
    }

    function syncAvailability() {
      var btn = submitButton();
      var soldOut = !!(btn && btn.disabled);
      var addBtn = bar.querySelector('.vt-sticky-atc__add');
      var buyBtn = bar.querySelector('.vt-sticky-atc__buy');
      [addBtn, buyBtn].forEach(function (b) {
        if (b) b.disabled = soldOut;
      });
      if (addBtn) {
        addBtn.textContent = soldOut
          ? (btn ? btn.textContent.trim() : 'Sold out')
          : 'Add to Cart';
      }
    }

    function syncAll() {
      syncPrice();
      syncVariantLabel();
      syncAvailability();
    }

    syncAll();

    // Fast path: variant pickers fire a native `change` (radio) or are
    // clicked directly; update the label immediately and re-check
    // price/availability shortly after Dawn's own re-render finishes.
    var debounceTimer = null;
    function scheduleSync() {
      syncVariantLabel();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncAll, 450);
    }
    scope.addEventListener('change', scheduleSync);
    scope.addEventListener('click', function (event) {
      if (event.target.closest('variant-radios, variant-selects, .product-form__input')) {
        scheduleSync();
      }
    });

    // Belt-and-braces: also watch for DOM swaps in case Dawn re-renders
    // price/availability without a plain `change` event reaching us.
    if (productInfo && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        syncAll();
      });
      observer.observe(productInfo, { childList: true, subtree: true });
    }

    function toggleVisibility() {
      var shouldShow = mq.matches;
      bar.hidden = !shouldShow;
      document.body.style.paddingBottom = shouldShow ? bar.offsetHeight + 'px' : '';
    }
    toggleVisibility();
    if (mq.addEventListener) {
      mq.addEventListener('change', toggleVisibility);
    } else if (mq.addListener) {
      mq.addListener(toggleVisibility);
    }
    window.addEventListener('resize', toggleVisibility);

    var variantToggle = bar.querySelector('.vt-sticky-atc__variant');
    if (variantToggle) {
      variantToggle.addEventListener('click', function () {
        var selectors = variantToggle.dataset.vtScrollTarget.split(',').map(function (s) {
          return s.trim();
        });
        var target = null;
        for (var i = 0; i < selectors.length; i++) {
          target = document.querySelector(selectors[i]);
          if (target) break;
        }
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.classList.add('vt-flash-highlight');
          setTimeout(function () {
            target.classList.remove('vt-flash-highlight');
          }, 1100);
        }
      });
    }

    bar.querySelectorAll('[data-vt-trigger]').forEach(function (triggerBtn) {
      triggerBtn.addEventListener('click', function () {
        if (triggerBtn.disabled) return;
        var selectors = triggerBtn.dataset.vtTrigger.split(',').map(function (s) {
          return s.trim();
        });
        for (var i = 0; i < selectors.length; i++) {
          var target = document.querySelector(selectors[i]);
          if (target) {
            target.click();
            return;
          }
        }
      });
    });
  }
})();
